import { memo } from 'react';

import { FileStatus } from '../../constants/FileStatus';
import { FileStatusIconCompleted } from './FileStatusIconCompleted';
import { FileStatusIconErrored } from './FileStatusIconErrored';
import { FileStatusIconPaused } from './FileStatusIconPaused';
import { FileStatusIconPreparing } from './FileStatusIconPreparing';
import { FileStatusIconProgressing } from './FileStatusIconProgressing';
import { FileStatusIconStopped } from './FileStatusIconStopped';

export type FileStatusIconProps = {
  status: FileStatus;
};

export const FileStatusIcon = memo(({ status }: FileStatusIconProps) => {
  switch (status) {
    case FileStatus.completed:
      return <FileStatusIconCompleted />;
    case FileStatus.paused:
      return <FileStatusIconPaused />;
    case FileStatus.stopped:
      return <FileStatusIconStopped />;
    case FileStatus.errored:
      return <FileStatusIconErrored />;
    case FileStatus.progressing:
      return <FileStatusIconProgressing />;
    case FileStatus.preparing:
    default:
      return <FileStatusIconPreparing />;
  }
});

FileStatusIcon.displayName = 'FileStatusIcon';
